



















































































import {
  Vue,
  Component,
} from "@/shared/vuepack";
import {
  UnreimburseExpense,
  ReimbursementRequest,
  GradientPoint,
  RgbColor
} from "@/shared/types";
import Chart from "@/shared/components/charts/Chart.vue";
import Widget from "@/shared/components/Widget.vue";
import Search from "@/shared/components/Search.vue";
import Button from "@/shared/components/ui/Button.vue";
import ExpenseRow from "@/shared/components/expenseV2/ExpenseRow.vue";
import UnreimbursedRow from "@/employee/components/healthcareExpenseV2/UnreimbursedRow.vue";
import BottomNotification from "@/shared/components/BottomNotification.vue";
import ReimburseMePopup from "@/employee/components/shared/ReimburseMePopup.vue";
import Pagination from "@/shared/components/ui/Pagination.vue";
import SliderArrow from "@/shared/components/ui/SliderArrow.vue";
import { formatCurrency } from "@/shared/currency";
import {
  tint,
  covertHexToRgbColor,
  convertColorToHex
} from "@/shared/colorAdjuster";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import PocGLineChart from "@/shared/components/charts/PocGLineChart.vue";
import { useExpenseUnreimbursedStore } from "@/employee/store/expenseUnreimbursed";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";
import { useExpenseBalanceSummaryStore } from "@/employee/store/expenseBalanceSummary";
import { useReimburseMeStore } from "@/employee/store/reimburseMe";
import { useThemeStore } from "@/shared/store/theme";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";

@Component({
  components: {
    Widget,
    Search,
    Button,
    ExpenseRow,
    BottomNotification,
    ReimburseMePopup,
    Pagination,
    SliderArrow,
    UnreimbursedRow,
    GenericLoadingSpinner,
    PocGLineChart
  }
})
export default class HealthcareExpensesUnreimbursed extends Vue {

  expenseUnreimbursedStore = useExpenseUnreimbursedStore();
  custodianSettingsStore = useCustodianSettingsStore();
  expenseBalanceSummaryStore = useExpenseBalanceSummaryStore();
  reimburseMeStore = useReimburseMeStore();
  themeStore = useThemeStore();
  featureFlagStore = useFeatureFlagStore();

  showReimbursePopup = false;
  formatCurrency = formatCurrency;

  negativeDataSetFillGradient: GradientPoint[] = [
    {
      alpha: 1.0,
      color: "#fff"
    },
    {
      alpha: 1.0,
      color: "#fff"
    }];

  mounted (): void {
    this.expenseUnreimbursedStore.load();
    this.expenseBalanceSummaryStore.loadState();

    this.negativeDataSetFillGradient = [
      {
        alpha: 1.0,
        color: this.lightenedSecondaryColor
      },
      {
        alpha: 1.0,
        color: this.lightenedSecondaryColor
      }];

  }

  onSwitchPage (pageNumber): void {
    this.expenseUnreimbursedStore.loadPage({ page: pageNumber } as any);
  }

  getUnreimbursedList (): UnreimburseExpense[] {
    return this.expenseUnreimbursedStore.getExpensesList(this.expenseUnreimbursedStore.currentPage);
  }

  reimburseToggle (expense): void {
    this.expenseUnreimbursedStore.toggle(expense);
  }

  reimburseToggleAll (): void {
    this.expenseUnreimbursedStore.toggleAll(!this.expenseUnreimbursedStore.currentPageSelected);
  }

  graphNavigateBack (): void {
    this.expenseUnreimbursedStore.graphMove(true);
  }

  graphNavigateForward (): void {
    this.expenseUnreimbursedStore.graphMove(false);
  }

  tooltipGenerator (item): string {
    const heading = `<strong class="tooltip-type">${item.date}</strong>`;
    const description = `<div>Unreimbursed balance</div>`;
    const balanceMarkup = `<div class="tooltip-up">${formatCurrency(item.amount)}</div>`;

    return `<div style="width: auto; height: auto; padding: 8px; background: #fff; ` +
      `color: #666;` +
      `font-size: 12px; pointer-events: none;">${heading}${description}${balanceMarkup}</div>`;
  }

  get bottomNotificationButtonText (): string {
    return this.custodianSettingsStore.allowReimbursement ? "Reimburse Me" : "Save";
  }

  handleNotificationClick (): void {
    if (this.custodianSettingsStore.allowReimbursement) {
      this.showReimbursePopup = true;
    } else {
      const params: ReimbursementRequest = {
        amount: this.reimburseAmount,
        reimbursementLinkedAccountId: 0,
        expenseIds: this.reimburseExpenseIds
      };
      this.reimburseMeStore.manualMarkedAsReimbursed(params);
    }
  }

  handleNotificationClose () {
    this.expenseBalanceSummaryStore.reimburseMeDismiss();
  }

  closeAll () {
    this.showReimbursePopup = false;
    this.expenseBalanceSummaryStore.reimburseMeDismiss();
  }

  get lightenedSecondaryColor (): string {
    const secondaryColorRgb: RgbColor = covertHexToRgbColor(this.themeStore.secondaryColor);
    const tintedColor: RgbColor = tint(secondaryColorRgb.r, secondaryColorRgb.g, secondaryColorRgb.b, 0.6);

    return convertColorToHex(tintedColor);
  }

  handleSwitchMode (value) {
    this.expenseUnreimbursedStore.switchMode(value);
  }

  get reimburseAmount () {
    return this.expenseBalanceSummaryStore.reimburseMeAmount.amount;
  }

  get reimburseExpenseIds () {
    return this.expenseBalanceSummaryStore.reimburseMeAmount.expenseIds;
  }
}
